import React, { useState, useEffect } from "react";
import { Card, CardTitle, CardBody } from "reactstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { CSVLink } from "react-csv";
import { FiDownload } from "react-icons/fi";
import { useApi } from "../../services/api";

export const ModuleUsageChart = () => {
  const { apiFetch } = useApi();
  const [usage, setUsage] = useState([]);

  useEffect(() => {
    async function loadData() {
      apiFetch("/api/analytics/moduleUsage")
        .then((response) => response.json())
        .then((data) => {
          setUsage(Array.isArray(data) ? data : []);
        })
        .catch(() => {
          alert("Error occured while loading module usage");
        });
    }
    loadData();
  }, [apiFetch]);

  const options = {
    chart: { type: "pie", height: 300 },
    title: { text: null },
    credits: { enabled: false },
    tooltip: { pointFormat: "<b>{point.y}</b> users ({point.percentage:.1f}%)" },
    plotOptions: {
      pie: {
        innerSize: "50%",
        dataLabels: { enabled: true },
      },
    },
    legend: { enabled: true },
    series: [
      {
        name: "Unique users",
        data: usage.map((row) => ({ name: row.module, y: row.unique_users })),
      },
    ],
  };

  const csvData = usage.map((row) => ({
    Module: row.module,
    Visits: row.visits,
    "Unique Users": row.unique_users,
  }));

  return (
    <Card className="shadow" data-testid="moduleUsageCard">
      <CardBody>
        <CardTitle style={{ textAlign: "left", display: "flex", justifyContent: "space-between" }}>
          <span>
            Module Usage <span style={{ fontSize: "12px", color: "#575757" }}>(last 30 days)</span>
          </span>
          <CSVLink data={csvData} filename={"module_usage.csv"} data-testid="moduleUsageCsvLink">
            <FiDownload style={{ color: "#4A42A0" }} />
          </CSVLink>
        </CardTitle>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </CardBody>
    </Card>
  );
};
